import React from "react";
import RoutesHeader from "modules/client/routes/components/header/RoutesHeader";
import "./SavedRoutesPage.scss";

const SavedRoutesPage = () => {
  const breadCrumbs = [{ text: "SAVED ROUTES" }];

  return (
    <div className="saved-routes-page">
      <RoutesHeader breadCrumbs={breadCrumbs} />
      <div className="content-wrapper">
        <div className="coming-soon-container">
          <h2 className="coming-soon-title">Coming Soon</h2>
          <p className="coming-soon-message">
            The Saved Routes feature is currently under development and will be available
            soon.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SavedRoutesPage;
